subscription PayCycleBankingDocumentPackageStatus($id: UUID!) {
  payCycleBankingDocumentPackageStatus(id: $id) {
    document {
      id
    }
    status
  }
}
